import React from "react";
import styles from "./OverviewItem.module.scss";
import { Typography } from "@material-ui/core";

interface Props {
  label: string;
  value?: React.ReactNode;
}

const OverviewItem = ({ label, value }: Props) => {
  return (
    <div className={styles.overviewItem}>
      <Typography variant="caption">{label}</Typography>
      <Typography variant="body2">{value}</Typography>
    </div>
  );
};

export default OverviewItem;
